"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
let WhaleBeanDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.alert_switch = false;
    this.short_message_switch = false;
    this.whale_bean_amount = 0;
    this.whale_bean_phone_number = "";
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v1/balance-alarm`);
        this.alert_switch = response.data.open;
        this.short_message_switch = response.data.sendShortMessage;
        this.whale_bean_amount = response.data.coinNumber;
        this.whale_bean_phone_number = response.data.phone;
        this._whale_bean_setting.show();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  closeDialog() {
    this._whale_bean_setting.hide();
  }
  saveSetting() {
    return __async(this, null, function* () {
      try {
        let data = {
          "open": this.alert_switch,
          "sendShortMessage": this.short_message_switch,
          "coinNumber": this.whale_bean_amount,
          "phone": this.whale_bean_phone_number
        };
        if (this.short_message_switch === true) {
          data = {
            "open": this.alert_switch,
            "sendShortMessage": this.short_message_switch,
            "coinNumber": this.whale_bean_amount,
            "phone": this.whale_bean_phone_number
          };
        }
        if (this.short_message_switch === false) {
          data = {
            "open": this.alert_switch,
            "sendShortMessage": this.short_message_switch,
            "coinNumber": this.whale_bean_amount
          };
        }
        yield API.post(`api://base.auth/api/v1/balance-alarm`, data);
        this.$message.success(this.$t("whale_bean_setting.save_success_tip"));
        this.closeDialog();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("whale-bean-setting")
], WhaleBeanDialog.prototype, "_whale_bean_setting", 2);
WhaleBeanDialog = __decorateClass([
  Component({
    components: { UiDialog }
  })
], WhaleBeanDialog);
export {
  WhaleBeanDialog as default
};
